module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"headlines":{"form":"Type to search the job name","table":"Select the relevant SOC code"},"placeholders":{"roleName":"Job name"},"counter":{"foundOne":"SOC code found","foundMany":"SOC codes found","notFound":"Sorry, we could’t find any matching SOC codes."}}}')
  delete Component.options._Ctor
}
